import Character, { ICharacterStats, IImages, ISkill } from "./characters/Character";
import { Mage } from "./characters/Mage";
import { Rogue } from "./characters/Rogue";
import { Warrior } from "./characters/Warrior";
import { bossArr, raceFullArr } from '../tempDB';
import { Armor, initArmor } from "./items/Armor";
import { initWeapon, Weapon } from "./items/Weapon";

import mediumArmor from '../assets/img/armor/3.png'
import mediumArmorWebp from '../assets/img/armor/3.webp'
import lightArmor from '../assets/img/armor/1.png'
import lightArmorWebp from '../assets/img/armor/1.webp'
import dagger from '../assets/img/weapon/dagger.png'
import daggerWebp from '../assets/img/weapon/dagger.webp'
import sword from '../assets/img/weapon/sword.png'
import swordWebp from '../assets/img/weapon/sword.webp'
import staff from '../assets/img/weapon/staff.png'
import staffWebp from '../assets/img/weapon/staff.webp'

const WARRIOR_CLASS: TClasses = "warrior"
const MAGE_CLASS: TClasses = "mage"
const ROGUE_CLASS: TClasses = "rogue"

export type TRace = "elf" | "halfling" | "demon"
export type TClasses = "warrior" | "mage" | "rogue"
export type TEnemydifficulty = "easy" | "medium" | "high" | "boss"

export const characterClasses: string[] = [ROGUE_CLASS, MAGE_CLASS, WARRIOR_CLASS]
export const characterRace: TRace[] = ["elf", "halfling", "demon"]

// * Выдача брони
const startMediumArmor = new Armor({ ...initArmor, initImages: {img: mediumArmor, webp: mediumArmorWebp}, initArmorType: 'medium' })
const startRobeArmor = new Armor({ ...initArmor, initImages: {img: lightArmor, webp: lightArmorWebp}, initArmorType: 'light' })

// * Выдача оружия
const startDagegr = new Weapon({ ...initWeapon, initImages: {img: dagger, webp: daggerWebp}, initWeaponType: 'dagger' })
const startSword = new Weapon({ ...initWeapon, initImages: {img: sword, webp: swordWebp}, initWeaponType: 'sword' })
const startStaff = new Weapon({ ...initWeapon, initImages: {img: staff, webp: staffWebp}, initWeaponType: 'staff' })

export const returnRaceMod = (race: TRace) => {
    switch (race) {
        case "elf":
            return {
                initConstitution: -2,
                initDexterety: 2,
                initStrength: 0,
                initCharm: 0,
                initWisdom: 0,
                initIntelligent: 2
            }
        case "demon":
            return {
                initConstitution: 0,
                initDexterety: 2,
                initStrength: 0,
                initCharm: -2,
                initWisdom: 0,
                initIntelligent: 2
            }
        case "halfling":
            return {
                initConstitution: 0,
                initDexterety: 2,
                initStrength: -2,
                initCharm: 2,
                initWisdom: 0,
                initIntelligent: 0
            }
        default:
            return {
                initConstitution: 0,
                initDexterety: 0,
                initStrength: 0,
                initCharm: 0,
                initWisdom: 0,
                initIntelligent: 0
            }
    }
}

export const warriorStats: ICharacterStats = {
    initHp: 22,
    initAttack: 1,
    initIsNpc: false,
    initName: '',
    initImgSmall: { webp: '', img: '' },
    initImgBig: raceFullArr[2],
    initConstitution: 10,
    initDexterety: 10,
    initStrength: 10,
    initCharm: 10,
    initIntelligent: 10,
    initWisdom: 10,
    initGold: 175,
    initSkills: [],
    initEquipment: { armor: startMediumArmor, weapon: startSword }
}

export const mageStats: ICharacterStats = {
    initHp: 18,
    initAttack: 0,
    initIsNpc: false,
    initName: '',
    initImgSmall: { webp: '', img: '' },
    initImgBig: raceFullArr[1],
    initConstitution: 10,
    initDexterety: 10,
    initStrength: 10,
    initCharm: 10,
    initIntelligent: 10,
    initWisdom: 10,
    initGold: 300,
    initSkills: [],
    initEquipment: { armor: startRobeArmor, weapon: startStaff }
}

export const rogueStats: ICharacterStats = {
    initHp: 20,
    initAttack: 0,
    initIsNpc: false,
    initName: '',
    initImgSmall: { webp: '', img: '' },
    initImgBig: raceFullArr[0],
    initConstitution: 10,
    initDexterety: 10,
    initStrength: 10,
    initCharm: 10,
    initIntelligent: 10,
    initWisdom: 10,
    initGold: 140,
    initSkills: [],
    initEquipment: { armor: startMediumArmor, weapon: startDagegr }
}

export const defaultStats: ICharacterStats = {
    initHp: 22,
    initAttack: 0,
    initIsNpc: false,
    initName: '',
    initImgSmall: { webp: '', img: '' },
    initImgBig: { webp: '', img: '' },
    initConstitution: 10,
    initDexterety: 10,
    initStrength: 10,
    initCharm: 10,
    initIntelligent: 10,
    initWisdom: 10,
    initGold: 70,
    initSkills: [],
    initEquipment: { armor: new Armor(initArmor), weapon: new Weapon(initWeapon) }
}

export const bossStats: ICharacterStats = {
    initHp: 50,
    initAttack: 5,
    initIsNpc: false,
    initName: '',
    initImgSmall: { webp: '', img: '' },
    initImgBig: bossArr[0],
    initConstitution: 10,
    initDexterety: 10,
    initStrength: 10,
    initCharm: 10,
    initIntelligent: 10,
    initWisdom: 10,
    initGold: 175,
    initSkills: [],
    initEquipment: { armor: new Armor(initArmor), weapon: new Weapon(initWeapon) }
}

export const characterStatsArr = [rogueStats, mageStats, warriorStats, defaultStats]

function statCalc(charStats: ICharacterStats, raceStats: object) {
    const statsWithMod = { ...charStats, ...raceStats }

    const newStats = {
        ...charStats,
        initConstitution: charStats.initConstitution + statsWithMod.initConstitution,
        initDexterety: charStats.initDexterety + statsWithMod.initDexterety,
        initStrength: charStats.initStrength + statsWithMod.initStrength,
        initCharm: charStats.initCharm + statsWithMod.initCharm,
        initIntelligent: charStats.initIntelligent + statsWithMod.initIntelligent,
        initWisdom: charStats.initWisdom + statsWithMod.initWisdom
    }

    return newStats
}

export interface ICreationParams {
    name: string
    characterClass: string
    activeRace: number
    img: IImages
    icon: IImages
    skills: ISkill[]
}

export function createNewCharacter(creationParams: ICreationParams) {
    switch (creationParams.characterClass) {
        case WARRIOR_CLASS:
            return new Warrior({
                ...statCalc(warriorStats, returnRaceMod(characterRace[creationParams.activeRace])),
                initName: creationParams.name,
                initImgBig: creationParams.img,
                initImgSmall: creationParams.icon,
                initSkills: creationParams.skills
            })
        case MAGE_CLASS:
            return new Mage({
                ...statCalc(mageStats, returnRaceMod(characterRace[creationParams.activeRace])),
                initName: creationParams.name,
                initImgBig: creationParams.img,
                initImgSmall: creationParams.icon,
                initSkills: creationParams.skills
            })
        case ROGUE_CLASS:
            return new Rogue({
                ...statCalc(rogueStats, returnRaceMod(characterRace[creationParams.activeRace])),
                initName: creationParams.name,
                initImgBig: creationParams.img,
                initImgSmall: creationParams.icon,
                initSkills: creationParams.skills
            })
        default:
            return new Character({
                ...statCalc(warriorStats, returnRaceMod(characterRace[creationParams.activeRace])),
                initName: creationParams.name,
                initImgBig: creationParams.img,
                initImgSmall: creationParams.icon,
                initSkills: creationParams.skills
            })
    }
}

export function countStatMod(stat: number) {
    return stat % 2 === 0 ? (stat - 10) / 2 : (stat - 11) / 2
}